export default "__VITE_ASSET__DBLH2A_6__"